import script from "./AppCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCarousel.vue?vue&type=script&setup=true&lang=js"

import "./AppCarousel.vue?vue&type=style&index=0&id=76d3dd8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d3dd8e"]])

export default __exports__